export enum EGameScreenMode {
  one = 1,
  two = 2,
  four = 4,
}

export enum EGameSideBarTab {
  Tournament = 'Tournament',
  Favorite = 'Favorite',
  none = 'none',
}
